<div class="auth-container">
  <div class="auth-logo">
      <img src="../../../assets/logo/logo-app.png" alt="Aikya Logo">
  </div>
  
  <div class="auth-card">
    <div class="container" [ngClass]="{'right-panel-active': isRegisterMode}">
      <div class="form-container register-container">
        <h2>Đăng Ký</h2>
        <form [formGroup]="registerForm" (ngSubmit)="onRegister()">
          <div class="form-row">
            <div class="form-group">
              <input type="text" formControlName="username" placeholder="Tên đăng nhập">
              <div *ngIf="registerForm.get('username')?.invalid && registerForm.get('username')?.touched" class="error-message">
                Vui lòng nhập tên đăng nhập
              </div>
            </div>
            <div class="form-group">
              <input type="email" formControlName="email" placeholder="Email">
              <div *ngIf="registerForm.get('email')?.invalid && registerForm.get('email')?.touched" class="error-message">
                Vui lòng nhập email hợp lệ
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <input type="text" formControlName="fullname" placeholder="Họ và tên">
              <div *ngIf="registerForm.get('fullname')?.invalid && registerForm.get('fullname')?.touched" class="error-message">
                Vui lòng nhập họ và tên
              </div>
            </div>
            <div class="form-group">
              <input type="text" formControlName="phone" placeholder="Số điện thoại">
              <div *ngIf="registerForm.get('phone')?.invalid && registerForm.get('phone')?.touched" class="error-message">
                Vui lòng nhập số điện thoại
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <input type="password" formControlName="password" placeholder="Mật khẩu">
              <div *ngIf="registerForm.get('password')?.invalid && registerForm.get('password')?.touched" class="error-message">
                Vui lòng nhập mật khẩu
              </div>
            </div>
            <div class="form-group">
              <input type="password" formControlName="confirmPassword" placeholder="Xác nhận mật khẩu">
              <div *ngIf="registerForm.get('confirmPassword')?.invalid && registerForm.get('confirmPassword')?.touched" class="error-message">
                Vui lòng xác nhận mật khẩu
              </div>
              <div *ngIf="registerForm.hasError('passwordMismatch') && registerForm.get('confirmPassword')?.touched" class="error-message">
                Mật khẩu không khớp
              </div>
            </div>
          </div>
          <div class="form-check">
            <input type="checkbox" id="terms" formControlName="acceptTerms">
            <label for="terms">Tôi đồng ý với <a href="#">Điều khoản</a> và <a href="#">Chính sách</a></label>
            <div *ngIf="registerForm.get('acceptTerms')?.invalid && registerForm.get('acceptTerms')?.touched" class="error-message">
              Bạn cần đồng ý với điều khoản
            </div>
          </div>
          <div *ngIf="registerError" class="error-alert">
            {{ registerError }}
          </div>
          <button type="submit" class="submit-btn" [disabled]="isRegistering">
            <span *ngIf="isRegistering">Đang đăng ký...</span>
            <span *ngIf="!isRegistering">Đăng ký</span>
          </button>
        </form>
      </div>
      
      <div class="form-container login-container">
        <h2>Đăng Nhập</h2>
        <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
          <div class="form-group">
            <input type="text" formControlName="username" placeholder="Tên đăng nhập">
            <div *ngIf="loginForm.get('username')?.invalid && loginForm.get('username')?.touched" class="error-message">
              Vui lòng nhập tên đăng nhập
            </div>
          </div>
          <div class="form-group">
            <input type="password" formControlName="password" placeholder="Mật khẩu">
            <div *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched" class="error-message">
              Vui lòng nhập mật khẩu
            </div>
          </div>
          <div class="form-check">
            <input type="checkbox" id="remember" formControlName="rememberMe">
            <label for="remember">Ghi nhớ đăng nhập</label>
          </div>
          <div *ngIf="loginError" class="error-alert">
            {{ loginError }}
          </div>
          <button type="submit" class="submit-btn" [disabled]="isLoggingIn">
            <span *ngIf="isLoggingIn">Đang đăng nhập...</span>
            <span *ngIf="!isLoggingIn">Đăng nhập</span>
          </button>
        </form>
      </div>
      
      <div class="overlay-container">
        <div class="overlay">
          <div class="overlay-panel overlay-left">
            <div class="overlay-logo">
              <img src="../../../assets/logo/logo-app.png" alt="Logo">
            </div>
            <h2>Đã có tài khoản?</h2>
            <p>Đăng nhập để tiếp tục phiên làm việc và sử dụng các tính năng của hệ thống.</p>
            <button class="auth-btn" (click)="switchMode(false)">
              Đăng nhập
            </button>
          </div>
          
          <div class="overlay-panel overlay-right">
            <div class="overlay-logo">
              <img src="../../../assets/logo/logo-app.png" alt="Logo">
            </div>
            <h2>Bạn chưa có tài khoản?</h2>
            <p>Vui lòng đăng ký để truy cập vào hệ thống quản lý và sử dụng đầy đủ các tính năng.</p>
            <!-- <button class="auth-btn" (click)="switchMode(true)">
              Đăng ký
            </button> -->
          </div>
        </div>
      </div>
    </div>
    
    <div class="mobile-nav">
      <button class="mobile-btn" [ngClass]="{'active': !isRegisterMode}" (click)="switchMode(false)">Đăng nhập</button>
      <button class="mobile-btn" [ngClass]="{'active': isRegisterMode}" (click)="switchMode(true)">Đăng ký</button>
    </div>
  </div>
</div>